export default __webpack_public_path__ + "static/media/register-modal.58840a12.png";